import styled from 'styled-components';
import { mobileThreshold } from '../../../../../../Constants/layoutValues';

export const CopyrightWrapper = styled.div`
	flex: 1;
	text-align: right;
	color: rgba(0, 0, 0, 0.5);
	@media (max-width: ${mobileThreshold}px) {
		padding-top: 1em;
		text-align: center;
		font-size: 0.7em;
	}
`;
